<div class="topbar" data-testid="shell-topbar">
  <!-- Left slot: the SECTION label for screens that adopted the new shell
       (NBO-2388). Empty on every other route — legacy screens keep their own
       page header — and the collapse toggle lives at the rail foot. On an entity
       page the label IS the back action (canon §3b, NBO-2532); the page's h1 is
       then the entity's name in its masthead. A singleton page the rail does not
       hold (Settings, NBO-2545) claims its own label: plain text, no chevron, and
       not a heading — that page's h1 is its masthead too. -->
  @if (backTarget(); as target) {
    <button
      type="button"
      class="topbar-back"
      data-testid="topbar-back"
      [attr.aria-label]="'nav.topbar.back_to' | translate: { section: (backLabelKey() | translate) }"
      (click)="goBack(target)"
    >
      <span class="topbar-back__chevron" aria-hidden="true"></span>
      <span class="topbar-section topbar-back__label" data-testid="topbar-section-label">{{ backLabelKey() | translate }}</span>
    </button>
  } @else if (pageLabelKey(); as labelKey) {
    <span class="topbar-section" data-testid="topbar-section-label">{{ labelKey | translate }}</span>
  } @else if (sectionLabelKey(); as labelKey) {
    <h1 class="topbar-section" data-testid="topbar-section-label">{{ labelKey | translate }}</h1>
  }
  <div class="topbar-right">
    <app-topbar-quick-create />

    <!-- Built to the mockup, hidden until NBO-2207 ships a backend. -->
    @if (notificationsEnabled) {
      <app-topbar-notifications />
    }

    <!-- IDENTITY CLUSTER — tenant · language · user are ONE group with ONE
         reveal (r4). Each holds its final geometry with still placeholders
         while pending and shows no fabricated value, so the bar resolves in a
         single 140ms fade instead of three staggered pops. The language code
         is known at boot but waits with the group: one real trigger between
         two placeholders reads as broken. -->
    <div class="topbar-identity" [class.nbo-reveal]="identityReady()">
      <app-topbar-tenant-switcher />
      <app-topbar-language-switcher />

      <span class="topbar-divider"></span>

      <app-topbar-user-menu />
    </div>
  </div>
</div>
